/**
 * FlatListV2 - A drop-in replacement for React Native's FlatList
 *
 * Use FlatListV2 instead of FlatList when:
 * • Rendering lists inside modals on web (FlatList doesn't scroll properly in web modals)
 * • Working with large datasets (250+ items) that cause performance issues on web
 * • Need consistent scrolling behavior across web and native platforms
 *
 * Key benefits:
 * • 100% API compatible with FlatList - no code changes needed
 * • Automatically uses virtual scrolling on web for better performance
 * • Solves web modal scrolling issues (blank areas, partial rendering)
 * • Maintains native FlatList performance on iOS/Android
 *
 * Simply replace: import { FlatList } from 'react-native'
 * With: import FlatListV2 from '@omni/kit/components/FlatListV2';
 */

// React Native Web will automatically resolve:
// - FlatListV2.native.tsx on React Native
// - FlatListV2.web.tsx on Web
export { default } from './FlatListV2';
